import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'delta', 'IconDelta', [["path",{"d":"M4 20h16l-8 -16z","key":"svg-0"}]]);